import { motion } from 'framer-motion';
import ScrollReveal from '@/components/base/ScrollReveal';

const benefits = [
  { icon: 'ri-time-line', title: 'Ahorra horas de trabajo', desc: 'Deja de partir de cero. Cada prompt está listo para usar y adaptar.' },
  { icon: 'ri-lightbulb-line', title: 'Genera mejores ideas', desc: 'Supera el bloqueo creativo con prompts probados por expertos.' },
  { icon: 'ri-magic-line', title: 'Aumenta la creatividad', desc: 'Descubre ángulos y enfoques que nunca habías considerado.' },
  { icon: 'ri-line-chart-line', title: 'Mejora conversiones', desc: 'Prompts diseñados específicamente para vender más y mejor.' },
  { icon: 'ri-flashlight-line', title: 'Crea anuncios más rápido', desc: 'De horas a minutos. La IA hace el trabajo pesado por ti.' },
  { icon: 'ri-cpu-line', title: 'Usa IA profesionalmente', desc: 'Aprende a sacar el máximo provecho de ChatGPT y Gemini.' },
  { icon: 'ri-shield-check-line', title: 'Contenido probado', desc: 'Cada prompt está testado y optimizado para resultados reales.' },
];

export default function Benefits() {
  return (
    <section className="relative bg-white py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              Ventajas
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              Beneficios
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
              No solo son prompts. Es un sistema completo para transformar tu marketing con IA.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((b, i) => (
            <ScrollReveal key={b.title} delay={i * 0.07}>
              <motion.div
                whileHover={{ y: -4, transition: { duration: 0.25 } }}
                className="bg-foreground-50 rounded-2xl p-6 md:p-7 border border-transparent hover:border-foreground-200 hover:shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-white border border-foreground-100 flex items-center justify-center mb-4">
                  <i className={`${b.icon} text-primary-500 text-lg`} />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {b.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {b.desc}
                </p>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}